import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { getInvoicesList } from '@/utils/invoices';
import { tryParseInt } from '@/utils/number';

export const documentInvoicesRoute: RouteConfig = {
  path: 'invoices',
  name: 'documentInvoices',
  component: () => import(/* webpackChunkName: "DocumentInvoices" */ '@/views/mainRoute/document/details/Invoices.vue'),
  meta: { breadcrumb: { title: 'Dokumenty księgowe' } },
  beforeEnter(to, from, next) {
    const documentId = to.params.documentId;
    store.commit('documentIndex/setId', tryParseInt(documentId));
    Promise.all([
      getInvoicesList(to),
      store.dispatch('documentIndex/get'),
      store.dispatch('setting/findPublic', {
        code: PublicSettings.DECISION_DATA_DATES_DICTIONARY
      })
    ])
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.INVOICE_CANNOT_LIST }));
  }
};
